import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';
import Store from 'store/store';
import { getDynamicData } from 'utils/bolt/dynamicData';
import { geoFromIP } from 'utils/bolt/geo';

// import s from 'components/bolt/footer/footer.sss';

export default class Footer extends BaseComp.default {

	async componentDidMount() {
		super.componentDidMount?.();

		if (this.props.store?.appData?.options?.cmsManaged) {
			await this.loadCustomData(await getDynamicData('landing'));
		}
	}

	async loadCustomData(dynamicData) {
		if (!dynamicData) return;
		const geo = await geoFromIP();
		const isUS = geo?.countryCode?.toLowerCase() === 'us';

		const dynamicLinks = (dynamicData.footer?.copyLinks || []).map((link, i) => ({
			order: i,
			$copy: link.name,
			url: link.link,
		}));

		const cookieLink = {
			$copy: isUS ? 'Your Privacy Choices' : 'Cookie Notice',
			url: 'javascript:window.OneTrust.ToggleInfoDisplay()',
			order: dynamicLinks.length,
			showPrivacyChoicesLogo: isUS,
		};

		const caLink = {
			$copy: 'CA Notice',
			url: 'https://www.nbcuniversal.com/privacy/california-consumer-privacy-act?intake=Universal_Pictures',
			order: dynamicLinks.length + 1,
		};

		this.footerData = {
			...this.footerData,
			links: [
				...dynamicLinks,
				cookieLink,
				isUS && caLink,
			],
		};

		this.forceUpdate();
	}

	handleClick(e) {
		const link = e.target.closest('footer a');
		if (link) {
			Store.emit('CUSTOM_EVENT', {
				category: 'footer',
				action: 'footer-legal-link-click',
				label: link.textContent || link.querySelector('img')?.alt || link.href,
			});
		}
	}

	render(props, state) {
		const base = super.render(props, state);
		base.attributes.onClick = this.handleClick;
		return base;
	}
}
